// function navbar() {
//   // Mobile Menu
//   $('.navbar-item[class*="has-sub-"] .nav-arrow').on('click', function (e) {
//     const menuparent = $(this).closest('[class*="has-sub-"]');
//     const that = $(this);
//     if (!that.hasClass('is-active')) {
//       menuparent.children('.navbar-dropdown').slideDown();
//       menuparent.addClass('is-active').siblings('.has-sub-second').removeClass('is-active');
//     } else {
//       menuparent.removeClass('is-active').addClass('is-removed');
//     }
//     if (!$('body').hasClass('submenu-open')) {
//       $('body').addClass('submenu-open');
//     }
//   });

//   // Adds back menu option to mobile nav
//   // $('.navbar-item[class*="has-sub-"]').each(function () {
//   //   const parentlink = $(this).find('> .navbar-link').clone();
//   //   $(this).find('> .navbar-dropdown').prepend('<div class="parent-link"></div>');
//   //   $(this).find('.parent-link').prepend(parentlink);
//   // });

//   // Closes submenu on click
//   $('.parent-link a').on('click', function (e) {
//     e.preventDefault();
//     const menuparent = $(this).closest('[class*="has-sub-"]');
//     if (menuparent.hasClass('is-active')) {
//       menuparent.removeClass('is-active');
//     }
//     if (!$('.navbar-item').hasClass('is-active')) {
//       $('body').removeClass('submenu-open');
//     }
//   });

//   $('[class*="navbar-dropdown"]').on('click', (e) => {
//     e.stopPropagation();
//   });
// }

// $('.quicklinks-container').on('click', function() {
//   $('.quicklinks-container').removeClass('is-active');
//   $('.quicklinks-container .sidebar-links-menu').removeClass('is-active');
//   $(this).toggleClass('is-active');
//   $(this).find('.sidebar-links-menu').toggleClass('is-active');
// });

// function wowo() {
//   const wTop = $(window).scrollTop();
//   const wHeight = $(window).height();
//   const wBottom = wTop + wHeight;
//   $('.wowo:not(.animated)').each(function () {
//     const me = $(this);
//     const meTop = me.offset().top;
//     const meHeight = me.innerHeight();
//     const meBottom = meTop + meHeight;
//     const limitTop = wTop - meHeight;
//     const limitBottom = wBottom + meHeight;
//     if (meTop > limitTop && meBottom < limitBottom) {
//       me.addClass('animated');
//       setTimeout(() => {
//         me.removeClass('animated wowo');
//       }, 1500);
//     }
//   });
// }

// function stickysidebar() {
//   if ($('.insight-sidebar-c').length > 0) {
//     const $anchor = $('.pages-main');
//     const $scroller = $('.sidebar-trigger');

//     const move = function () {
//       const st = $(window).scrollTop();
//       const ot = $anchor.offset().top;
//       if (st > ot) {
//         $scroller.addClass('is-stuck');
//       } else {
//         $scroller.removeClass('is-stuck');
//       }
//     };
//     move();
//   }
// }

// function pagetop() {
//   if (window.scrollY == 0) {
//     $('body').addClass('is-page-top');
//     $('body').addClass('hero-scrolling');
//   }
// }

// function bodyscrollclasses() {
//   if (window.scrollY == 0) {
//     $('body').removeClass('hero-complete');
//     $('body').removeClass('menu-stuck');
//     $('.navigation').removeClass('is-stuck');
//   } else {
//     $('body').removeClass('is-page-top');
//     $('body').removeClass('hero-scrolling');
//   }
// }

// // function pagebottom() {
// //   // detects if element is in viewport
// //   $.fn.isInViewport = function () {
// //     const elementTop = $(this).offset().top;
// //     const elementBottom = elementTop + $(this).outerHeight();

// //     const viewportTop = $(window).scrollTop();
// //     const viewportBottom = viewportTop + $(window).height();

// //     return elementBottom > viewportTop && elementTop < viewportBottom;
// //   };
// //   $(window).on('resize scroll', () => {
// //     if ($('.footers').isInViewport()) {
// //       $('body').addClass('is-bottom');
// //     } else {
// //       $('body').removeClass('is-bottom');
// //     }
// //   });
// // }

// function heroslides() {
//   gsap.registerPlugin(ScrollTrigger);

//   if ($('.block-hero-slides').length) {
//     gsap.registerPlugin(ScrollTrigger);

//     desktophero();

//     function mobilehero() {
//       const tl = gsap.timeline({
//         scrollTrigger: {
//           trigger: '.block-hero-slides',
//           pin: true,
//           start: 'top top',
//           end: 'bottom top',
//           id: 'Slide 1b',
//           scrub: 1,
//           markers: false,
//           toggleClass: {
//             targets: 'body',
//             className: 'hero-scrolling',
//           },
//         },
//       });

//       tl.fromTo(
//         '.slide2',
//         {
//           yPercent: 100,
//           ease: 'power3',
//         },
//         {
//           yPercent: 0,
//           ease: 'power3',
//         },
//       );
//     }

//     function desktophero() {
//       ScrollTrigger.matchMedia({
//         '(min-width: 1024px)': function () {
//           const tl = gsap.timeline({
//             scrollTrigger: {
//               trigger: '.block-hero-slides',
//               pin: true,
//               start: 'top top',
//               end: '+=500',
//               anticipatePin: 3,
//               markers: false,
//               id: 'Pinned area',
//               toggleClass: {
//                 targets: 'body',
//                 className: 'hero-scrolling',
//               },
//             },
//           });
//           const t2 = gsap.timeline({
//             scrollTrigger: {
//               trigger: '.slide2',
//               start: 'top top',
//               // end: "bottom-+=1000 top",
//               markers: false,
//               // scrub: 5,
//               // snap: 0.2,
//               toggleActions: 'play resume resume reverse',
//               id: 'center tl',
//               toggleClass: {
//                 targets: 'body',
//                 className: 'hero-slide2',
//               },
//             },
//           });
//           const currentTimeScale = t2.timeScale();
//           t2.timeScale(1.5);
//           t2.fromTo(
//             '.slide2',
//             {
//               y: 50,
//             },
//             {
//               y: 0,
//             },
//           )
//             .fromTo(
//               '.slide2',
//               {
//                 display: 'none',
//               },
//               {
//                 display: 'block',
//               },
//             )
//             .to('.mask', {
//               width: '100%',
//             })
//             .fromTo(
//               '.hero-content',
//               {
//                 opacity: 0,
//                 y: 540,
//               },
//               {
//                 opacity: 1,
//                 y: 0,
//                 duration: 0.5,
//                 ease: Power2.easeOut,
//               },
//             )
//             .from('.hero-img', {
//               opacity: 0,
//               y: 540,
//               duration: 1.5,
//               ease: Power2.easeOut,
//             });
//         },
//       });
//     }
//   }
// }

// $(window).scroll(() => {
//   wowo();
//   pagetop();
//   bodyscrollclasses();
//   stickysidebar();
// });

// $(document).ready(function () {
//   navbar();
//   pagetop();
//   heroslides();
//   //pagebottom();
//   $('[class*="has-sub-"] > a.navbar-link').after("<span class='nav-arrow'></span>");
// });
